import { ActivityPurchasesItemFormType } from './form-type';

export function activityPurchaseGuestDetailCalculation({
  activityPurchaseGuestDetails,
}) {
  return (activityPurchaseGuestDetails || []).reduce(
    (prev, curr) => prev + (curr.totalPrice || 0),
    0,
  );
}

export function activityPurchaseGuestCalculation({ activityPurchaseGuests }) {
  return activityPurchaseGuests.reduce(
    (prev, curr) =>
      prev +
      activityPurchaseGuestDetailCalculation({
        activityPurchaseGuestDetails: curr.activityPurchaseGuestDetails,
      }),
    0,
  );
}

export default function totalCalculation({
  activityPurchases,
  discount,
  otherCost,
}: {
  activityPurchases: ActivityPurchasesItemFormType[];
  discount: number;
  otherCost: number;
}) {
  let tempTotal: number = 0;
  tempTotal = activityPurchases.reduce((prev, curr) => {
    const details = activityPurchaseGuestCalculation({
      activityPurchaseGuests: curr.activityPurchaseGuests,
    });

    const addons = (curr.activityPurchaseAddOns || []).reduce(
      (prev, curr) => prev + curr.price,
      0,
    );

    return prev + details + addons;
  }, 0);

  tempTotal -= discount || 0;
  tempTotal += otherCost || 0;
  return tempTotal;
}
